// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { createRestaurant } from '../../services/restaurantService';

// function CreateRestaurant() {
//   const [name, setName] = useState('');
//   const [address, setAddress] = useState('');
//   const [description, setDescription] = useState('');
//   const [profileImage, setProfileImage] = useState(null);
//   const [optOutWord, setOptOutWord] = useState('');
//   const navigate = useNavigate();

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const formData = new FormData();
//     formData.append('name', name);
//     formData.append('address', address);
//     formData.append('description', description);
//     if (profileImage) {
//       formData.append('profileImage', profileImage);
//     }
//     try {
//       await createRestaurant({
//         name,
//         address,
//         description,
//         profileImage,
//         optOutWord,
//       });
//       navigate('/owner/dashboard');
//     } catch (error) {
//       alert('Failed to create restaurant.');
//     }
//   };

//   const handleImageChange = (e) => {
//     setProfileImage(e.target.files[0]);
//   };

//   return (
//     <div className='flex flex-col items-center justify-center min-h-screen '>
//       <h2 className='text-2xl font-bold mb-4'>Create New Restaurant</h2>
//       <form onSubmit={handleSubmit} className='w-full max-w-md'>
//         <div className='mb-4'>
//           <label className='block text-gray-700'>Store Name</label>
//           <input
//             type='text'
//             value={name}
//             onChange={(e) => setName(e.target.value)}
//             className='w-full p-2 border rounded'
//           />
//         </div>
//         <div className='mb-4'>
//           <label className='block text-gray-700'>Address</label>
//           <input
//             type='text'
//             value={address}
//             onChange={(e) => setAddress(e.target.value)}
//             className='w-full p-2 border rounded'
//           />
//         </div>
//         <div className='mb-4'>
//           <label className='block text-gray-700'>Description</label>
//           <textarea
//             value={description}
//             onChange={(e) => setDescription(e.target.value)}
//             className='w-full p-2 border rounded'
//           />
//         </div>
//         <div className='mb-4'>
//           <label className='block text-gray-700'>Profile Image</label>
//           <input
//             type='file'
//             onChange={handleImageChange}
//             className='w-full p-2'
//           />
//         </div>
//         <button
//           type='submit'
//           className='bg-green-500 text-white px-4 py-2 rounded'
//         >
//           Create Restaurant
//         </button>
//       </form>
//     </div>
//   );
// }

// export default CreateRestaurant;

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createRestaurant } from '../../services/restaurantService';
import { useDropzone } from 'react-dropzone';

function CreateRestaurant() {
  const [formData, setFormData] = useState({
    name: '',
    address: '',
    description: '',
    image: null,
    optOutWord: '',
  });
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onDrop = (acceptedFiles) => {
    if (acceptedFiles[0]) {
      setFormData((prev) => ({ ...prev, image: acceptedFiles[0] }));
    }
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      'image/jpeg': ['.jpg', '.jpeg'],
      'image/png': ['.png'],
      'image/gif': ['.gif'],
    },
    multiple: false,
  });

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const formDataToSend = new FormData();
      formDataToSend.append('name', formData.name);
      formDataToSend.append('address', formData.address);
      formDataToSend.append('description', formData.description);
      formDataToSend.append('optOutWord', formData.optOutWord);

      if (formData.image instanceof File) {
        formDataToSend.append('image', formData.image);
      }

      await createRestaurant(formDataToSend);
      navigate('/owner/dashboard');
    } catch (error) {
      alert('Failed to create restaurant.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className='max-w-md mx-auto mt-10 px-4'>
      <h2 className='text-2xl font-bold mb-4'>Create New Restaurant</h2>
      <form onSubmit={handleSubmit} className='space-y-4'>
        <div>
          <label className='block text-sm font-medium text-gray-700'>
            Store Name
          </label>
          <input
            type='text'
            value={formData.name}
            onChange={(e) => handleInputChange('name', e.target.value)}
            className='p-2 mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50'
            required
          />
        </div>
        <div>
          <label className='block text-sm font-medium text-gray-700'>
            Address
          </label>
          <input
            type='text'
            value={formData.address}
            onChange={(e) => handleInputChange('address', e.target.value)}
            className='p-2 mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50'
          />
        </div>
        <div>
          <label className='block text-sm font-medium text-gray-700'>
            Description
          </label>
          <textarea
            value={formData.description}
            onChange={(e) => handleInputChange('description', e.target.value)}
            className='p-2 mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50'
          />
        </div>
        <div>
          <label className='block text-sm font-medium text-gray-700 mb-2'>
            Upload Image (Optional)
          </label>
          <div
            {...getRootProps()}
            className={`dropzone border-2 border-dashed rounded-lg p-4 text-center cursor-pointer transition-colors duration-200 ease-in-out ${
              isDragActive
                ? 'border-indigo-600 bg-indigo-50'
                : 'border-gray-300 hover:border-indigo-400'
            }`}
          >
            <input {...getInputProps()} />
            {isDragActive ? (
              <p className='text-indigo-600'>Drop the image here ...</p>
            ) : (
              <div>
                <p className='text-gray-600'>
                  Drag 'n' drop an image here, or click to select one
                </p>
                <p className='text-sm text-gray-500 mt-1'>
                  Supported formats: JPG, PNG, GIF
                </p>
              </div>
            )}
          </div>
          {formData.image && (
            <div className='mt-2 flex items-center'>
              <span className='text-sm text-gray-600'>
                {formData.image.name}
              </span>
              <button
                type='button'
                onClick={() => handleInputChange('image', null)}
                className='ml-2 text-red-600 hover:text-red-800 text-sm'
              >
                Remove
              </button>
            </div>
          )}
          {formData.image && (
            <div className='mt-4'>
              <h3 className='text-lg font-semibold mb-2'>Image Preview</h3>
              <img
                src={URL.createObjectURL(formData.image)}
                alt='Upload preview'
                className='max-w-full h-auto rounded-lg shadow-md'
              />
            </div>
          )}
        </div>
        <button
          type='submit'
          className='w-full bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-700 disabled:bg-indigo-300'
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Creating...' : 'Create Restaurant'}
        </button>
      </form>
    </div>
  );
}

export default CreateRestaurant;
